module.exports = __webpack_public_path__ + "img/chat_bot_2.3d9f8c6d.webp";